import { getJsonObject } from './index.js';
/**
 * Simplify Monarch's auto-request format by returning rules
 * in a single group instead of separate rule sets.
 */
export function formatMonarchEvaluations(monarchResult) {
    if (!monarchResult) {
        return null;
    }
    const ruleSets = [];
    for (const ruleSet of Object.values(monarchResult)) {
        ruleSets.push(ruleSet);
    }
    const rules = {};
    for (const ruleSet of ruleSets) {
        for (const [ruleId, ruleReturn] of Object.entries(ruleSet)) {
            rules[ruleId] = ruleReturn;
        }
    }
    return rules;
}
/**
 * Format a Preamp asset placement returned by Monarch so that it matches the format returned by Preamp.
 */
export function formatPreampAssetPlacement(assetPlacement) {
    if (!assetPlacement || !assetPlacement.asset) {
        return null;
    }
    let { asset, placement } = assetPlacement;
    if (!placement) {
        placement = {
            name: 'undefined',
            placementId: 'undefined',
            selector: 'undefined',
            urlMatch: 'undefined',
        };
    }
    const result = {
        placementId: placement.placementId,
        placementName: placement.name,
        selector: placement.selector,
        urlMatch: placement.urlMatch,
        assetId: asset.assetId,
        assetName: asset.name,
    };
    result.html = asset.html;
    result.css = asset.css;
    result.js = asset.js;
    result.metadata = getJsonObject(asset.metadata);
    return result;
}
/**
 * Format a Preamp experience returned by Monarch so that it matches the format returned by Preamp.
 */
export function formatPreampExperience(experience) {
    if (!experience) {
        return null;
    }
    const result = {
        experienceId: experience.experienceId,
        experienceName: experience.name,
        experienceNumber: experience.experienceNumber,
        placements: [],
    };
    if (experience.assetPlacements?.length) {
        for (const ap of experience.assetPlacements) {
            const assetPlacement = formatPreampAssetPlacement(ap);
            if (assetPlacement) {
                result.placements.push(assetPlacement);
            }
        }
    }
    return result;
}
